// Mensagens que a loja de add-ons (react-gestao, em iframe dentro do Meus Pagamentos) manda
// para a casca — card 17ttyenb92p.
//
// Depois de contratar, trocar plano, cancelar ou mexer em licença, a loja avisa o window.top
// para o sidenav recarregar o menu na hora (o item do módulo aparece sem recarregar a página).

// Mensagem que a loja manda quando os módulos contratados mudaram.
export const MODULOS_ALTERADOS = 'SEGFY_MODULOS_ALTERADOS'

// Origem da react-gestao. A old ainda não tem VUE_APP_REACT_GESTAO nos .env (veio na qa);
// até lá vale o VUE_APP_APP2, que aponta para a mesma react-gestao em QA e prod.
function origemDaLoja () {
  return new URL(process.env.VUE_APP_REACT_GESTAO || process.env.VUE_APP_APP2).origin
}

/**
 * O aviso veio mesmo da loja? Confere a origem: qualquer página aberta em iframe pode mandar
 * postMessage para cá.
 */
export function ehAvisoDeModulosAlterados (evento) {
  let origemLoja
  try {
    origemLoja = origemDaLoja()
  } catch (e) {
    return false
  }
  const dados = evento && evento.data
  return !!evento && evento.origin === origemLoja &&
    !!dados && dados.type === MODULOS_ALTERADOS
}
